import { observer } from 'mobx-react';
import { FC, FormEvent } from 'react';
import BackNextButtons from 'components/BackNextButtons';
import Compliance from 'components/forms/Compliance';
import JobInfo from 'components/forms/JobInfo';
import QuestionnaireEntry from 'components/forms/QuestionnaireEntry';
import TrustedContactPerson, { TrustedContactPersonDataItem } from 'components/forms/TrustedContactPerson';
import { usePowerNavigate } from 'components/PowerNavigate';
import { reportEventList } from 'utils/gtag';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';

const Job: FC<ProgressFormProps> = ({ onSubmit }) => {
    const navigate = usePowerNavigate();
    const handleAdd = () => {
        // 跳转到添加受信人的二级页面
        navigate('../trusted-contact', { state: { type: 'add' } });
    };

    const handleEdit = (data: TrustedContactPersonDataItem) => {
        navigate('../trusted-contact', { state: { type: 'edit', data } });
    };

    const handleClickEntry = () => {
        navigate('../qualification-questionnaire');
    };

    const handleSubmit = (ev: FormEvent) => {
        onSubmit(() => {
            reportEventList('job');

            navigate('../invest');
        }, ev);
    };

    return (
        <form noValidate className="open-job-root" onSubmit={handleSubmit}>
            <JobInfo />
            <Compliance />
            <QuestionnaireEntry onClick={handleClickEntry} />
            <TrustedContactPerson onAdd={handleAdd} onEdit={handleEdit} />
            <BackNextButtons sticky />
        </form>
    );
};

export default withProgressForm({
    step: 2.5,
    id: 'job',
    ensure: ['baseinfo', 'baseinfo2'],
    basePath: 'open',
    eventParams: {
        exposureEventParams: {
            model: '开户-职业规管信息',
            name: '规管职业信息-页面曝光'
        },
        submitEventParams: {
            model: '开户-职业规管信息',
            name: '规管职业信息-下一步'
        }
    }
})(observer(Job));
